let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("am7CN")).then(() => parcelRequire('38yqm'));